import { FeatureToggleClientService } from 'feature-toggle-client';
export const APPLICATION_LIST_NAME = 'auth.application.list';
const CAN_USE_TEMPLATE_HEADSTART = 'can-create-template-headstart';
const CAN_ACCESS_TEMPLATE_HEADSTART = 'can-access-template-headstart';
const CAN_EDIT_DELETE_TEMPLATE_HEADSTART = 'can-edit-delete-template-headstart';
export const MARKETPLACE_OPENED = 'marketplace-opened';
const TEMPLATE_VISIBILITY = 'marketplace-template-visibility';
export class MarketplaceFeatures {
    static isCreateHeadstartTemplateEnabled() {
        return FeatureToggleClientService.getInstance()
            .isUserFeatureEnabled(CAN_USE_TEMPLATE_HEADSTART);
    }
    static isAccessHeadstartTemplateEnabled() {
        return FeatureToggleClientService.getInstance()
            .isFeatureEnabled(CAN_ACCESS_TEMPLATE_HEADSTART);
    }
    static isEditDeleteHeadstartTemplateEnabled() {
        return FeatureToggleClientService.getInstance()
            .isFeatureEnabled(CAN_EDIT_DELETE_TEMPLATE_HEADSTART);
    }
    static async isTemplateVisibilityEnabled() {
        return FeatureToggleClientService.getInstance()
            .isFeatureEnabled(TEMPLATE_VISIBILITY);
    }
}
